import { Grid } from '@mui/material'
import { styled } from '@mui/system'

const shouldForwardProp = (prop) => !['columns'].includes(prop)

const Root = styled(Grid)`
	padding-top: 27px;
	${({ theme }) => theme.breakpoints.up('md')} {
		max-width: 440px;
		padding-top: 0;
	}
`
const OptionsWrapper = styled('div', { shouldForwardProp })`
	display: ${({ columns }) => (columns > 1 ? 'grid' : 'block')};
	grid-template-columns: repeat(${({ columns }) => columns}, 1fr);
	gap: ${({ theme, columns }) => (columns >= 2 ? theme.spacing(4) : 0)};
	margin-top: ${({ theme }) => theme.spacing(4)};
	${({ theme }) => theme.breakpoints.up('sm')} {
		margin-top: ${({ theme }) => theme.spacing(5)};
	}
	> .MuiGrid-root {
		margin-bottom: ${({ theme }) => theme.spacing(2)};
		&:last-of-type {
			margin-bottom: 0;
		}
	}
	div[role='group'] {
		display: table;
	}
`

export { Root, OptionsWrapper }
